import type { BaseFeatureFlags } from '@/features/feature-flags/types/base-feature-flags';
import originalBaseFeatureFlags from '@base-impl/features/feature-flags/constants/base-feature-flags';
import { merge } from 'lodash-es';
import type { PartialDeep } from 'type-fest';

export default merge<PartialDeep<BaseFeatureFlags>, PartialDeep<BaseFeatureFlags>>(originalBaseFeatureFlags, {
  page: {
    product: {
      enableDirectInquiry: true,
      enableTireDot: true,
    }
  },
  component: {
    checkout: {
      enableDeliveryOption: true,
      enableShippingAddressOption: true,
      enableOrderPrecheck: true,
    },
  },
  push: {
    enabled: true
  }
}) as BaseFeatureFlags;
